import { Link } from "react-router-dom";
import FeaturedCompanyBlock from "./FeaturedCompanyBlock";
import {
  getCompanySponsorRating,
  getCompanySponsorType,
  getCompanyStrength,
  getSponsorTypeBadge,
} from "../../../helpers/helpers";
import paths from "../../../constants/paths";

// const featuredCompanies = [
//     {
//       id: 1,
//       color: "#1355FF",
//       name: "TechCorp Solutions",
//       icon: "images/icon_tech_crop.png",
//       featured: true,
//       activeSponsor: true,
//       description:
//         "Leading software development company specializing in enterprise solutions and cloud technologies.",
//       stats: [
//         { icon: "images/icon_mini_file.png", text: "289 CoS Issued" },
//         { icon: "images/icon_mini_shield.png", text: "A-rated Sponsor" },
//         {
//           icon: "images/icon_mini_chart.png",
//           text: "Sponsorship Strength: Strong",
//         },
//         {
//           icon: "images/icon_mini_check.png",
//           text: "Sponsors Overseas Candidates",
//         },
//         {
//           icon: "images/icon_mini_visa.png",
//           text: "Sponsors Skilled Worker Visa",
//         },
//       ],
//       tags: ["Tech", "Engineering", "Product"],
//       openPositions: 24,
//     },
//     {
//       id: 2,
//       color: "#9333EA",
//       name: "DesignHub Inc",
//       icon: "images/icon_design_hub.png",
//       featured: true,
//       activeSponsor: true,
//       description:
//         "Creative agency delivering exceptional design experiences for Fortune 500 companies worldwide.",
//       stats: [
//         { icon: "images/icon_mini_file.png", text: "187 CoS Issued" },
//         { icon: "images/icon_mini_shield.png", text: "A-rated Sponsor" },
//         {
//           icon: "images/icon_mini_chart.png",
//           text: "Sponsorship Strength: Strong",
//         },
//         {
//           icon: "images/icon_mini_graduation_cap.png",
//           text: "Previously Sponsored Graduates",
//         },
//         {
//           icon: "images/icon_mini_visa.png",
//           text: "Sponsors Skilled Worker Visa",
//         },
//       ],
//       tags: ["Design", "Creative", "Marketing"],
//       openPositions: 18,
//     },
//     {
//       id: 3,
//       color: "#16A34A",
//       name: "GrowthLabs",
//       icon: "images/icon_growth_lab.png",
//       featured: true,
//       activeSponsor: true,
//       description:
//         "Marketing technology platform helping businesses scale through data-driven strategies.",
//       stats: [
//         { icon: "images/icon_mini_file.png", text: "321 CoS Issued" },
//         { icon: "images/icon_mini_shield.png", text: "A-rated Sponsor" },
//         {
//           icon: "images/icon_mini_chart.png",
//           text: "Sponsorship Strength: Strong",
//         },
//         {
//           icon: "images/icon_mini_check.png",
//           text: "Sponsors Overseas Candidates",
//         },
//         {
//           icon: "images/icon_mini_visa.png",
//           text: "Sponsors Skilled Worker Visa",
//         },
//       ],
//       tags: ["Marketing", "Analytics", "SaaS"],
//       openPositions: 32,
//     },
//   ];

export default function FeaturedCompanies({ content, featured_companies }) {
  const featuredCompanies = featured_companies.map((company, index) => ({
    id: company?.id,
    encoded_id: company?.encoded_id,
    color: "#1355FF",
    name: company?.title,
    image: company?.image,
    featured: company?.is_featured ? true : false,
    activeSponsor: getSponsorTypeBadge(company?.sponsor_type),
    description: company?.short_desc,
    stats: [
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_file.png",
        text: company?.computed_cos_total + " CoS Issued",
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_shield.png",
        text: getCompanySponsorRating(company?.sponsor_rating),
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_chart.png",
        text: "Sponsorship Strength: " + getCompanyStrength(company?.strength),
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_check.png",
        text:
          company?.overseas_applicants == "yes"
            ? "Accepts applicants from overseas candidates."
            : "Does not accept applicants from overseas",
      },
      {
        icon: paths.SITE_BASE_URL + "/images/icon_mini_visa.png",
        text: company?.visa_support,
      },
    ],
    tags: company.industry_tags,
    openPositions: company?.open_positions,
  }));

  return (
    <>
      <div className="feature_companies_wrapper">
        <div className="top_head">
          <div className="text">
            <h3>{content?.featured_heading}</h3>
            <p>{content?.featured_tagline}</p>
          </div>
        </div>
        <div className="row form_row">
          {featuredCompanies?.map((company) => (
            <div className="col-md-4 d-flex" key={company.id}>
              <FeaturedCompanyBlock key={company.id} company={company} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
